// Page
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';

// Viewport
export const SET_VIEWPORT = 'SET_VIEWPORT';
export const SET_PAGE_VISIBILITY = 'SET_PAGE_VISIBILITY';

// Logos
export const SET_LOGO = 'SET_LOGO';

// sidebar blocks
export const SET_SIDEBAR_OPEN_BLOCK = 'SET_SIDEBAR_OPEN_BLOCK';
export const SET_SIDEBAR_BLOCK_ID = 'SET_SIDEBAR_BLOCK_ID';
export const SET_SIDEBAR_BLOCK_BOUNDS = 'SET_SIDEBAR_BLOCK_BOUNDS';

// Side navitation
export const TOGGLE_SIDE_NAVIGATION = 'TOGGLE_SIDE_NAVIGATION';
